@if (isLoading) {
  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
    <div class="panel-dummy">
    <div class="shine"></div>
  </div>
    <div class="panel-dummy">
    <div class="shine"></div>
  </div>
}
@else {
<!-- CCAP Details -->
<div>
  <h2 class="panel-title">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.CCAPDetails' | translate }}</h2>
  <div class="details-card">
    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.Serial' | translate }}</h4>
      <div class="detail-value">{{ ccap.deviceId }}</div>
    </div>
    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.State' | translate }}</h4>
      <div class="detail-value">{{ getOnlineStatus() }}</div>
    </div>
    <div>
      <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteMaintenanceItemInfoData.FirmwareVersion' | translate }}</h4>
      <div class="detail-value">{{ ccap.firmware }}</div>
    </div>
  </div>
</div>

<!-- Active problems -->
<div *ngIf="('devices' | hasPermission :'Device_Problems':'read' | async)">
  <h2 class="panel-title">{{ 'Modules.RemoteMaintenance.Problems.AllActiveIssues' | translate }}</h2>

  <div *ngIf="currentProblems?.length; then active_problems else no_active_problems"></div>

  <ng-template #active_problems>
    <div class="panel">
      <app-list-item *ngFor="let problem of currentProblems" title="{{ getProblemTitle(problem) }}"
        info="{{ (problem.startUtc | localizedDate: 'short') + ' - ' + getProblemInfo(problem) }}"></app-list-item>
    </div>
  </ng-template>

  <ng-template #no_active_problems>
    <p class="p-form-group">{{ 'Modules.RemoteMaintenance.Problems.NoActiveIssues' | translate }}</p>
  </ng-template>
</div>

<!-- Store info -->
<div *ngIf="('devices' | hasPermission :'Store':'read' | async)">
  <h2 class="panel-title">{{ 'Modules.XPACManagementComponent.StoreInfoComponent.StoreDetails' | translate }}</h2>

  <xpac-store-info [xpac]="ccap" [readOnly]="true"></xpac-store-info>
</div>
}

